import React from "react";
import { Toolbar, ToolbarGroup } from "../../molecules/Toolbar";
import {
  Button,
  Callout,
  Intent,
  FormGroup,
  Spinner,
  Breadcrumbs,
  Breadcrumb
} from "@blueprintjs/core";
import FormInfo from "../../atoms/FormInfo/FormInfo";
import MdEditor from "react-markdown-editor-lite";
// import style manually
import "react-markdown-editor-lite/lib/index.css";
import MarkdownIt from "markdown-it";
import insert from "markdown-it-ins";
import { useChangeConfirmationEmail } from "./hook";
import styles from "./ConfirmationEmail.module.scss";
import { Page } from "../../layouts/Page";
const mdParser = new MarkdownIt({ html: true }).use(insert);

export default function ConfirmationEmail({ history, match }) {
  const productId = match.params.id;

  const {
    confirmationEmail,
    setConfirmationEmail,
    isSaving,
    error,
    saveChanges,
    resetEmail,
    resetEnabled,
    loading,
    isSaveEnabled,
    productName
  } = useChangeConfirmationEmail({ productId });

  const BREADCRUMBS = [
    {
      text: "Products",
      onClick: () => history.push("/products")
    },
    {
      text: productName
    }
  ];

  if (loading) {
    return (
      <div className={styles.centered}>
        <Spinner />
      </div>
    );
  }

  return (
    <Page title="Your Products" flex>
      <Toolbar title="Order Email Receipts">
        <ToolbarGroup>
          <Button
            text="Reset"
            intent={Intent.PRIMARY}
            disabled={!resetEnabled}
            onClick={resetEmail}
            className={styles.resetBtn}
          />
          <Button
            text="Save"
            intent={Intent.PRIMARY}
            loading={isSaving}
            disabled={!isSaveEnabled}
            onClick={() => saveChanges()}
          />
        </ToolbarGroup>
      </Toolbar>

      <div className={styles.breadcrumbs}>
        <Breadcrumbs
          items={BREADCRUMBS}
          currentBreadcrumbRenderer={({ text, ...restProps }) => (
            <Breadcrumb className={styles.breadcrumb} {...restProps}>
              {text}
            </Breadcrumb>
          )}
        />
      </div>

      {error && (
        <Callout
          icon="error"
          intent={Intent.DANGER}
          title="We couldn't save your settings."
        >
          {error.message}
        </Callout>
      )}

      <div className={styles.editor}>
        <MdEditor
          value={confirmationEmail}
          renderHTML={(text) => mdParser.render(text.slice(0, 1000))}
          onChange={({ text }) => setConfirmationEmail(text)}
        />
        <FormInfo>Max Length: 1000</FormInfo>
      </div>
    </Page>
  );
}
